<template>
    <div>
        <vs-button v-if="$store.state.is_online && $store.state.is_mobile" @click="show_offline=!show_offline" 
            color="primary" size="small" type="filled" class="mb-2 p-2 py-1" style="margin-left: auto;">
            Show {{ show_offline ? "Online" : "Offline" }} Data
        </vs-button>
        <template v-if="$store.state.is_online && !show_offline">
            <OnlineList />
        </template>
        <template v-else>
            <CacheList />
        </template>
    </div>
</template>

<script>
import OnlineList from './OnlineList.vue';
import CacheList from './CacheList.vue'

export default {
    components: {
        OnlineList,
        CacheList
    },
    data() {
        return {
            show_offline: false
        }
    }
}

</script>